import React from 'react';
import PropTypes from 'prop-types';

export default function ExternalLink({
  href, variant, className, onClick, children, style,
}) {
  const classNames = variant ? `btn btn-${variant} ${className}` : className;

  return (
    <a
      href={href}
      className={classNames}
      style={style}
      onClick={onClick}
      rel="noreferrer"
      target="_blank"
    >
      {children}
    </a>
  );
}

ExternalLink.propTypes = {
  href: PropTypes.string.isRequired,
  variant: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
};

ExternalLink.defaultProps = {
  variant: 'primary',
  className: '',
  onClick: () => {},
  style: {},
};
